import { objectToFormData } from "../../lib/bandung/api/helpers";
import { getPrefix, getSessionToken } from "../../lib/bandung/bandung";
import Axios from "axios";

const getConversationPrefix = () =>
  `https://startup4.ipserlab.com/app/conversation`;
const getConversationCreateEndPoint = () => `${getConversationPrefix()}/create`;
const getConversationViewEndPoint = () =>
  `${getConversationPrefix()}/view?conversationEntityId=`;
const getConversationUpdateShortDescriptionEndPoint = () =>
  `${getPrefix()}/app/conversation/updateshortdescription`;
const getConversationUpdateLongDescriptionEndPoint = () =>
  `${getPrefix()}/app/conversation/updatelongdescription`;
const getConversationUpdateEndPoint = () =>
  `${getPrefix()}/app/conversation/update`;
const getConversationDeleteEndPoint = () =>
  `${getPrefix()}/app/conversation/delete`;

export const conversationCreate = async ({
  userEntityId,
  label,
  name,
  order,
  shortDescription,
  longDescription,
}) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    userEntityId,
    label,
    name,
    order,
    shortDescription,
    longDescription,
  });
  try {
    const response = await Axios.post(getConversationCreateEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Conversation successfully created.",
        data: { conversationEntityId: response.data.conversationEntityId },
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export const conversationList = async () => {
  try {
    const response = await Axios.get(getConversationPrefix());
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Conversation list loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export const getConversationShortDescription = async (id) => {
  try {
    const response = await Axios.get(
      getConversationPrefix() +
        `/textshortdescription?conversationEntityId=${id}`
    );
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Conversation Short Description loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export const conversationTextShortDescription = async (id) => {
  try {
    const response = await Axios.get(
      getConversationPrefix() +
        `/textshortdescription?conversationEntityId=${id}`
    );
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Conversation Short Description loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export const conversationTextLongDescription = async (id) => {
  try {
    const response = await Axios.get(
      getConversationPrefix() +
        `/textlongdescription?conversationEntityId=${id}`
    );
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Conversation Long Description loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export const conversationView = async (conversationEntityId) => {
  try {
    const response = await Axios.get(
      getConversationViewEndPoint() + conversationEntityId
    );
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Announcement loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export const conversationUpdate = async ({
  conversationEntityId,
  label,
  name,
  shortDescription,
  longDescription,
}) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    conversationEntityId,
    label,
    name,
    shortDescription,
    longDescription,
  });
  try {
    const response = await Axios.post(getConversationUpdateEndPoint(), form);
    if (!response.data.error) {
      console.log("Conversation details updated successfully:", response.data);

      const shortResponse = await Axios.post(
        getConversationUpdateShortDescriptionEndPoint(),
        form
      );
      if (!shortResponse.data.error) {
        console.log(
          "Short description updated successfully:",
          shortResponse.data
        );

        const longResponse = await Axios.post(
          getConversationUpdateLongDescriptionEndPoint(),
          form
        );
        if (!longResponse.data.error) {
          console.log(
            "Long description updated successfully:",
            longResponse.data
          );

          return {
            code: "SUCCESS",
            message: "Conversation successfully updated.",
            data: { conversationEntityId: response.data.conversationEntityId },
          };
        } else {
          throw new Error(longResponse.data.error);
        }
      } else {
        throw new Error(shortResponse.data.error);
      }
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message:
        error.message || "An error occurred while updating the conversation.",
    };
  }
};

export const conversationDelete = async ({ conversationEntityId }) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    conversationEntityId,
  });

  try {
    const response = await Axios.post(getConversationDeleteEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Conversation successfully deleted.",
        data: { conversationEntityId: response.data.conversationEntityId },
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message:
        error.message || "An error occurred while deleting the conversation.",
    };
  }
};
